import React, { Component, createRef } from 'react'

class LevelSelector extends Component {
    constructor(props) {
        super(props)
        this.containerRef = createRef()

        this.levelRefs = []

        this.state = {
            showButtons: false,
            canScrollPrev: false,
            canScrollNext: false,
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.checkScroll()
        }, 200)
        window.addEventListener('resize', this.checkScroll)
        this.containerRef.current.addEventListener('scroll', this.checkScroll)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkScroll)
        if (this.containerRef.current) {
            this.containerRef.current.removeEventListener('scroll', this.checkScroll)
        }
    }

    checkScroll = () => {
        const container = this.containerRef.current
        if (!container) return

        const { scrollWidth, clientWidth, scrollLeft } = container

        this.setState({
            showButtons: scrollWidth > clientWidth,
            canScrollPrev: scrollLeft > 5,
            canScrollNext: scrollLeft + clientWidth < scrollWidth - 50,
        })
    }

handleNext = () => {
    const container = this.containerRef.current
    if (!container) return

    const containerScrollLeft = container.scrollLeft
    const containerRight = containerScrollLeft + container.clientWidth

    for (let i = 0; i < this.levelRefs.length; i += 1) {
        const tab = this.levelRefs[i]

        const tabLeft = (tab.offsetLeft - this.levelRefs[0].offsetLeft)

        if (tabLeft > (containerRight - tab.clientWidth)) {
            container.scrollTo({
                left: (tab.offsetLeft - this.levelRefs[0].offsetLeft) - (container.clientWidth - tab.clientWidth) + (containerScrollLeft === 0 ? 40 : 0) + 20,
                behavior: 'smooth',
            })
            return
        }
    }
}

handlePrev = () => {
    const container = this.containerRef.current
    if (!container) return

    const containerLeft = container.scrollLeft

    for (let i = this.levelRefs.length - 1; i >= 0; i -= 1) {
        const tab = this.levelRefs[i]
        const tabLeft = (tab.offsetLeft - this.levelRefs[0].offsetLeft)
        if (tabLeft < containerLeft) {
            container.scrollTo({
                left: (tab.offsetLeft - this.levelRefs[0].offsetLeft) - 20,
                behavior: 'smooth',
            })
            return
        }
    }
};

render() {
    const { levels, changeLevel, currentLevel } = this.props
    const { showButtons, canScrollPrev, canScrollNext } = this.state

    return (
        <div className="levels">
            {showButtons && canScrollPrev ? (
                <div style={{ display: 'flex', position: 'relative' }}>
                    <div
                        style={{
                            backgroundColor: '#EFF4F6',
                            width: '40px',
                            height: '40px',
                            minWidth: '40px',
                            border: '1px solid #CADAE1',
                            borderRadius: '6px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                        }}
                        onClick={this.handlePrev}
                    >
                        <i className="fa-regular fa-chevron-left" />
                    </div>
                    <div style={{
                        background: 'linear-gradient(90deg,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)',
                        width: '40px',
                        height: '40px',
                        minWidth: '20px',
                        position: 'absolute',
                        left: '40px',
                    }}
                    />
                </div>
            ) : <div style={{ minWidth: '0px' }} />}

            <div
                ref={this.containerRef}
                style={{
                    scrollBehavior: 'smooth',
                    display: 'flex',
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                    gap: '16px',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                }}
            >
                {levels.map(({ level, dashboard }, idx) => (
                    <div
                        key={idx}
                        ref={(el) => (this.levelRefs[idx] = el)}
                        style={{
                            fontWeight: 600,
                            fontSize: '16px',
                            cursor: 'pointer',
                            textWrap: 'nowrap',
                            padding: '0 8px',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            borderBottom: level === currentLevel ? 'solid 2px rgba(51, 225, 213, 1)' : 'none',
                        }}
                        onClick={() => changeLevel(level, dashboard)}
                    >
                        <div>
                            {level}
                        </div>
                    </div>
                ))}
            </div>

            {showButtons && canScrollNext ? (
                <div style={{ display: 'flex', position: 'relative' }}>
                    <div style={{
                        background: 'linear-gradient(90deg,rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%)',
                        width: '40px',
                        height: '40px',
                        minWidth: '20px',
                        position: 'absolute',
                        left: '-40px',
                    }}
                    />
                    <div
                        onClick={this.handleNext}
                        style={{
                            backgroundColor: '#EFF4F6',
                            width: '40px',
                            height: '40px',
                            minWidth: '40px',
                            border: '1px solid #CADAE1',
                            borderRadius: '6px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                        }}
                    >
                        <i className="fa-regular fa-chevron-right" />
                    </div>
                </div>
            ) : <div style={{ minWidth: '0px' }} />}
        </div>
    )
}
}

export default LevelSelector
